var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x9D\xD0\xB0\xD0\xB2\xD0\xB5\xD1\x80\xD1\x85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 70",
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 9,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8561 11.27L7.41414 18.712L6.70703 18.0049L14.8561 9.85583L15.2372 10.237L15.5632 10.5629L23.3863 18.386L22.6792 19.0931L14.8561 11.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41414 18.712L7.76769 19.0655L7.41414 19.4191L7.06058 19.0655L7.41414 18.712ZM14.8561 11.27L14.5025 10.9165L14.8561 10.5629L15.2096 10.9165L14.8561 11.27ZM6.70703 18.0049L6.35348 18.3584L5.99992 18.0049L6.35348 17.6513L6.70703 18.0049ZM14.8561 9.85583L14.5025 9.50228L14.8561 9.14873L15.2096 9.50228L14.8561 9.85583ZM23.3863 18.386L23.7398 18.0325L24.0934 18.386L23.7398 18.7396L23.3863 18.386ZM22.6792 19.0931L23.0327 19.4467L22.6792 19.8003L22.3256 19.4467L22.6792 19.0931ZM7.06058 18.3584L14.5025 10.9165L15.2096 11.6236L7.76769 19.0655L7.06058 18.3584ZM7.06058 17.6513L7.76769 18.3584L7.06058 19.0655L6.35348 18.3584L7.06058 17.6513ZM15.2096 10.2094L7.06058 18.3584L6.35348 17.6513L14.5025 9.50228L15.2096 10.2094ZM14.8837 10.5905L14.5025 10.2094L15.2096 9.50228L15.5908 9.88344L14.8837 10.5905ZM15.2096 10.9165L14.8837 10.5905L15.5908 9.88344L15.9167 10.2094L15.2096 10.9165ZM23.0327 18.7396L15.2096 10.9165L15.9167 10.2094L23.7398 18.0325L23.0327 18.7396ZM22.3256 18.7396L23.0327 18.0325L23.7398 18.7396L23.0327 19.4467L22.3256 18.7396ZM15.2096 10.9165L23.0327 18.7396L22.3256 19.4467L14.5025 11.6236L15.2096 10.9165Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.de2050a8dc4d9aa23d95fad0f97caf02.svg";
export { ForwardRef as ReactComponent };